import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M6 4a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4h5a1 1 0 1 1 0 2h-1.049l-.615 12.3a6 6 0 0 1-5.992 5.7H8.656a6 6 0 0 1-5.992-5.7L2.049 6H1a1 1 0 0 1 0-2h5ZM4.051 6l.61 12.2A4 4 0 0 0 8.656 22h6.688a4 4 0 0 0 3.995-3.8l.61-12.2H4.05ZM16 4H8a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Zm-7 6a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
